// Centralized Google review URLs.
// When the official Google Business Profile short link (g.page/r/.../review) becomes
// available, swap GOOGLE_REVIEW_URL below — every CTA across the site updates.
//
// CID resolved from https://maps.app.goo.gl/XifRuHwedNFxMS16A
//   FID:  0x865c98936d970d69:0xe185b3ee331c8f16
//   CID:  16250592666077400854

// Opens the Sons Guadalupe Google Maps listing directly via CID.
export const GOOGLE_MAPS_URL =
  "https://www.google.com/maps?cid=16250592666077400854";

// Until we have the official g.page/r/.../review composer link, send users
// to the Maps listing — they tap "Reviews" → "Write a review" (one extra tap).
// Functional and safe; no fabricated data.
export const GOOGLE_REVIEW_URL =
  "https://maps.app.goo.gl/XifRuHwedNFxMS16A";

export const GOOGLE_RATING_DISPLAY = "4.1";
